import { styled } from 'stitches.config'

export const HeroRoot = styled('div', {
  '& > div > div': {
    alignItems: 'stretch',
  },
})

export const ContentContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  padding: '30px 12px 0px 12px',

  '@bp3': {
    padding: '120px 24px 96px 24px',
    width: '50%',
    justifyContent: 'space-between',
    flex: 1,
  },
})
